import React from 'react'

export default class IconsDnDHiddenInput extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <g clipPath='url(#clip0_4158_4897)'>
                    <path
                        d='M7.15533 3.38408C8.70826 3.19901 10.2791 3.52729 11.6279 4.31877C12.9768 5.11026 14.0295 6.32146 14.6253 7.76741C14.6809 7.91709 14.6809 8.08173 14.6253 8.23141C14.3803 8.82541 14.0565 9.38375 13.6627 9.89141'
                        stroke='black'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.38933 9.4386C9.01213 9.80291 8.50692 10.0045 7.98253 9.99994C7.45814 9.99539 6.95651 9.78505 6.58569 9.41423C6.21488 9.04342 6.00454 8.54179 5.99998 8.0174C5.99543 7.493 6.19702 6.9878 6.56133 6.6106'
                        stroke='black'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M11.6527 11.666C10.7683 12.1899 9.78165 12.5174 8.75959 12.6263C7.73752 12.7352 6.70398 12.623 5.7291 12.2973C4.75422 11.9716 3.86081 11.4399 3.10949 10.7385C2.35816 10.0371 1.76651 9.18226 1.37468 8.23202C1.31912 8.08235 1.31912 7.9177 1.37468 7.76802C1.96577 6.33459 3.00579 5.13152 4.33868 4.33936'
                        stroke='black'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M1.33334 1.33325L14.6667 14.6666'
                        stroke='black'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_4158_4897'>
                        <rect width='16' height='16' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
